import React, { createContext, PropsWithChildren } from "react";

import { OnlineBanner } from "~/entities/bannerEntities";

/**
 * Banners for the current site and order type. Already filtered by template,
 * site, order type and schedule server side.
 */
const BannerContext = createContext<{
  banners: OnlineBanner[];
}>({
  banners: [],
});

type BannerContextProviderProps = {
  banners: OnlineBanner[];
};

export const BannerContextProvider: React.FC<
  PropsWithChildren<BannerContextProviderProps>
> = ({ banners, children }) => (
  <BannerContext.Provider value={{ banners }}>
    {children}
  </BannerContext.Provider>
);

export default BannerContext;
